import { render, staticRenderFns } from "./10xIncome.vue?vue&type=template&id=56e9727c&scoped=true&"
import script from "./10xIncome.vue?vue&type=script&lang=js&"
export * from "./10xIncome.vue?vue&type=script&lang=js&"
import style0 from "./10xIncome.vue?vue&type=style&index=0&id=56e9727c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e9727c",
  null
  
)

export default component.exports